import request from './request';


//-------------------账号密码登录
export function login(data) {
    return request({
        url: 'user/login',
        method: 'post',
        data
    })
}

// //-------------------基本配置 左侧菜单
// export function getConfig(data) {
//     return request({
//         url: `member/clientMenu/myMenu${data}`,
//         method: 'get',
//     })
// }

//-----------------下载及其他列表
export function getResources(data) {
    return request({
        url: `file/lists?cid=${data.cid}`,
        method: 'get',
    })
}

//-----------------下载及其他分类
export function getlistCate(data) {
    return request({
        url: `file/listCate`,
        method: 'get',
    })
}


//---------------联系人列表
export function contactsLists(data) {
    return request({
        url: `Contacts/lists?${data}`,
        method: 'get',
    })
}


// //---------------企业详情
// export function companyInfo() {
//     return request({
//         url: 'Company/detail',
//         method: 'get',
//     })
// }

// 新增联系人
export function addContacts(data) {
    return request({
        url: 'Contacts/add',
        method: 'post',
        data
    })
}

// 编辑联系人
export function editContacts(data) {
    return request({
        url: 'Contacts/edit',
        method: 'put',
        data
    })
}

//-----------------联系人详情
export function getContactsDetail(data) {
    return request({
        url: `Contacts/detail?contacts_long_id=${data.contacts_long_id}`,
        method: 'get',
    })
}


//---------------获取企业招聘列表
export function recruitList(data) {
    return request({
        url: `company_recruit/lists?${data}`,
        method: 'get',
    })
}

// 新增企业招聘
export function addRecruit(data) {
    return request({
        url: 'company_recruit/add',
        method: 'post',
        data
    })
}

// 编辑企业招聘
export function editRecruit(data) {
    return request({
        url: 'company_recruit/edit',
        method: 'put',
        data
    })
}

// 删除企业招聘
export function delRecruit(data) {
    return request({
        url: 'company_recruit/delete',
        method: 'delete',
        data
    })
}


//---------------获取胸卡列表
export function badgeList(data) {
    return request({
        url: `company_badge/lists?${data}`,
        method: 'get',
    })
}

// 新增胸卡
export function addBadge(data) {
    return request({
        url: 'company_badge/add',
        method: 'post',
        data
    })
}

// 编辑胸卡
export function editBadge(data) {
    return request({
        url: 'company_badge/edit',
        method: 'put',
        data
    })
}

// 删除胸卡
export function delBadge(data) {
    return request({
        url: 'company_badge/delete',
        method: 'delete',
        data
    })
}


// 获取国家区号
export function getPhoneCode(data) {
    return request({
        url: `company/getPhoneCode?${data}`,
        method: 'get',
    })
}

// // 获取类别
// export function getconfigdict(data) {
//     return request({
//         url: `config/dict?type=${data.type}`,
//         method: 'get',
//     })
// }

// // 增加参展申请
// export function addcompanyApply(data) {
//     return request({
//         url: 'companyApply/add',
//         method: 'post',
//         data
//     })
// }

// // 编辑参展申请
// export function editcompanyApply(data) {
//     return request({
//         url: 'companyApply/edit',
//         method: 'post',
//         data
//     })
// }

// // 参展申请详情
// export function companyApplydetail() {
//     return request({
//         url: `companyApply/detail`,
//         method: 'get',
//     })
// }

export function productTypelist() {
    return request({
        url: `ProductType/lists`,
        method: 'get',
    })
}

//---------------获取产品列表
export function productList(data) {
    return request({
        url: `product/lists?${data}`,
        method: 'get',
    })
}

//---------------产品信息详情
export function productDetails(data) {
    return request({
        url: `product/detail?${data}`,
        method: 'get',
    })
}

// 增加产品
export function addproduct(data) {
    return request({
        url: 'product/add',
        method: 'post',
        data
    })
}

// 编辑产品
export function editproduct(data) {
    return request({
        url: 'product/edit',
        method: 'put',
        data
    })
}


// 删除产品
export function delproduct(data) {
    return request({
        url: 'product/delete',
        method: 'delete',
        data
    })
}


// 编辑企业楣版字
export function editCompany(data) {
    return request({
        url: 'Company/edit',
        method: 'put',
        data
    })
}

//---------------企业楣版字详情
export function companyDetails(data) {
    return request({
        url: `Company/detail?${data}`,
        method: 'get',
    })
}

//---------------发票列表
export function invoiceList(data) {
    return request({
        url: `Invoice/lists?${data}`,
        method: 'get',
    })
}

// 添加发票
export function addInvoice(data) {
    return request({
        url: 'Invoice/add',
        method: 'post',
        data
    })
}

// 编辑发票
export function editInvoice(data) {
    return request({
        url: 'Invoice/edit',
        method: 'put',
        data
    })
}

//---------------发票详情
export function invoiceDetails(data) {
    return request({
        url: `Invoice/detail?invoice_long_id=${data.invoice_long_id}`,
        method: 'get',
    })
}

//企业营业执照和产品知识产权
export function editPic(data) {
    return request({
        url: 'Company/editPic',
        method: 'put',
        data
    })
}


// 邀请函背景图添加
export function addbackground(data) {
    return request({
        url: 'invitation_background/add',
        method: 'post',
        data
    })
}

// 邀请函背景图删除
export function delbackground(data) {
    return request({
        url: 'invitation_background/delete',
        method: 'delete',
        data
    })
}

// 邀请函背景图列表
export function backgroundList() {
    return request({
        url: `invitation_background/lists`,
        method: 'get',
    })
}

// 生成邀请函
export function addinvitation(data) {
    return request({
        url: 'invitation/add',
        method: 'post',
        data
    })
}

// 生成邀请函列表
export function invitationList() {
    return request({
        url: `invitation/lists`,
        method: 'get',
    })
}

// 邀请函背景图删除
export function delinvitation(data) {
    return request({
        url: 'invitation/delete',
        method: 'delete',
        data
    })
}

// 删除联系人
export function delContacts(data) {
    return request({
        url: 'Contacts/delete',
        method: 'delete',
        data
    })
}

// 展商菜单获取富文本
export function companyMenuDetail(data) {
    return request({
        url: `CompanyMenu/detail?id=${data.id}`,
        method: 'get',
    })
}

// // 展商展示范围
// export function exhibitionScope(data) {
//     return request({
//         url: `/exhibition_scope/lists?page_type=0`,
//         method: 'get',
//     })
// }

// // 应用行业
// export function applicationIndustry(data) {
//     return request({
//         url: `applicationIndustry/lists?page_type=0`,
//         method: 'get',
//     })
// }




//------------------基本配置 左侧菜单详情
export function getDetail(data) {
    return request({
        url: `exhibitor/menu/detail?detail_id=${data}`,
        method: 'get',
    })
}

// //------------------左侧菜单 进度状态
// export function getStep(data) {
//     return request({
//         url: `exhibitor/menu/step${data ? `?menu_mark=${data.step}` : ''}`,
//         method: 'get',
//     })
// }

// //-----------------修改进度状态
// export function updateStep(data) {
//     return request({
//         url: 'exhibitor/menu/updatestep',
//         method: 'post',
//         data,
//     })
// }

//---------------基础信息
export function sessionInfo() {
    return request({
        url: 'exhibitor/accessibility/session',
        method: 'get',
    })
}


// //---------------认证统计
// export function certificationStatistics() {
//     return request({
//         url: 'exhibitor/company/certificationStatistics',
//         method: 'get',
//     })
// }

//---------------统计列表
// export function authenticatedList(data) {
//     return request({
//         url: `exhibitor/company/authenticated?${data}`,
//         method: 'get',
//     })
// }

// //--------------移除认证人员
// export function removeVerifier(data) {
//     return request({
//         url: 'exhibitor/company/remove_user',
//         method: 'post',
//         data,
//     })
// }


//---------------产品信息 添加、编辑、删除
export function productHandle(method, data) {
    return request({
        url: 'exhibitor/product/one',
        method,
        data,
    })
}

//---------------产品信息详情
// export function productDetails(data) {
//     return request({
//         url: `exhibitor/product/one?${data}`,
//         method: 'get',
//     })
// }

// //---------------标摊服务 获取信息／更新信息
// export function building(method, data) {
//     return request({
//         url: 'exhibitor/company/building',
//         method,
//         data,
//     })
// }

//---------------邀请用户列表
export function userRegister(data) {
    return request({
        url: `exhibitor/company/userregister?${data}`,
        method: 'get',
    })
}

//---------------展商企业类型
export function companyType() {
    return request({
        url: 'exhibitor/company/ctype',
        method: 'GET',
    })
}

// //---------------企业产品类别
// export function companyPtype() {
//     return request({
//         url: 'exhibitor/company/ptype',
//         method: 'GET',
//     })
// }

// //---------------展商商贸接口
// export function businessLabel() {
//     return request({
//         url: 'exhibitor/company/business',
//         method: 'GET',
//     })
// }

// //---------------展商信息
// export function companyInfo() {
//     return request({
//         url: 'exhibitor/company/info',
//         method: 'get',
//     })
// }

//---------------保存草稿
export function draft(data) {
    return request({
        url: 'exhibitor/company/draft',
        method: 'PUT',
        data,
    })
}

//---------------提交审核
export function submitCompanyInfo(data) {
    return request({
        url: 'exhibitor/company/info',
        method: 'PUT',
        data,
    })
}

//--------------保存责任书
export function saveResponsibility(data) {
    return request({
        url: 'exhibitor/company/responsibility',
        method: 'post',
        data,
    })
}

//---------------获取责任书
export function getResponsibility() {
    return request({
        url: 'exhibitor/company/responsibility',
        method: 'get',
    })
}

//-------------获取动态小程序码
export function getCode(data) {
    return request({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "APIVER": "v4.0",
        },
        responseType: 'base64',
        method: 'get',
        url: `exhibitor/company/getCode?${data}`,
    })
}

//-------------获取报道通知
export function getNotice() {
    return request({
        url: 'exhibitor/company/invitation',
        method: 'get',
        responseType: 'blob',
    })
}

//--------------下载记录
export function download(data) {
    return request({
        url: 'exhibitor/menu/download',
        method: 'post',
        data,
    })
}

//-------------自定义邀请函背景
export function setBackground(method, data) {
    return request({
        url: 'exhibitor/company/background',
        method,
        data
    })
}

//-------------已制作的邀请函背
export function makeBackground(method, data) {
    return request({
        url: 'exhibitor/company/invitation_image',
        method,
        data
    })
}

//---------------获取展商筛选项
export function optionList() {
    return request({
        url: 'exhibitor/company/optionList',
        method: 'get',
    })
}

// 以下为会员接口 赵
// 跳过 已知悉
export function skipOrReadStep(data) {
    return request({
        url: 'member/clientMenu/skipOrReadStep',
        method: 'post',
        data
    })
}


//-------------------注册 赵 2024年10月29日13:47:48
export function register(data) {
    return request({
        url: 'member/login/register',
        method: 'post',
        data
    })
}

//-------------------登录 赵 2024年11月4日16:53:03
export function SignInaccount(data) {
    return request({
        url: 'member/Login/account',
        method: 'post',
        data
    })
}

//-------------------基本配置 左侧菜单 赵
export function getmyMenu(data) {
    return request({
        url: `member/clientMenu/myMenu?${data}`,
        method: 'get',
    })
}
//-------------------菜单详情 赵
export function clientMenu_detail(data) {
    return request({
        url: `member/clientMenu/detail?${data}`,
        method: 'get',
    })
}

//---------------委员会选项 赵
export function ccompanyTypeList(data) {
    return request({
        url: `member/Committee/lists?${data}`,
        method: 'get',
    })
}

//---------------获取会员等级 赵
export function MemberLevel_lists(data) {
    return request({
        url: `member/MemberLevel/lists?${data}`,
        method: 'get',
    })
}

//---------------获取会员端字典 赵
export function DictLists(data) {
    return request({
        url: `member/Dict/lists?${data}`,
        method: 'get',
    })
}

//---------------获取会员详细信息 赵
export function MembersDetail(data) {
    return request({
        url: `member/Members/detail?${data}`,
        method: 'get',
    })
}
//---------------获取右侧信息 赵
export function SinglePageDetail(data) {
    return request({
        url: `member/SinglePage/detail?${data}`,
        method: 'get',
    })
}

//---------------保存个人 企业 会员信息 赵
export function MembersEdit(data) {
    return request({
        url: `member/Members/edit`,
        method: 'put',
        data
    })
}

//---------------提交个人 企业 会员信息 赵
export function MembersSubmit(data) {
    return request({
        url: `member/Members/submit`,
        method: 'put',
        data
    })
}

//---------------会员撤销提交信息 赵
export function MembersRevoke(data) {
    return request({
        url: `member/Members/revoke`,
        method: 'put',
        data
    })
}

//------------------账号密码登出 赵
export function logOut() {
    return request({
        url: 'member/login/logout',
        method: 'post',
    })
}
//------------------测试正式会员是否可以交费 赵
export function paymentByYear() {
    return request({
        url: 'member/order/paymentByYear',
        method: 'get',
    })
}

// 获取国家省市区三级联动
export function getLocationTree(data) {
    return request({
        url: `member/locations/getLocationTree`,
        method: 'get',
    })
}


// 获取品牌列表
export function MemberBrandLists(data) {
    return request({
        url: `member/MemberBrand/lists?${data}`,
        method: 'get',
    })
}

// 添加品牌
export function MemberBrand_add(data) {
    return request({
        url: `member/MemberBrand/add`,
        method: 'post',
        data
    })
}

// 删除品牌
export function MemberBrand_delete(data) {
    return request({
        url: `member/MemberBrand/delete`,
        method: 'delete',
        data
    })
}

// 品牌详情
export function MemberBrand_detail(data) {
    return request({
        url: `member/MemberBrand/detail?${data}`,
        method: 'get',

    })
}

// 品牌修改保存
export function MemberBrand_edit(data) {
    return request({
        url: `member/MemberBrand/edit`,
        method: 'put',
        data
    })
}


// 创建新增模特
export function MemberModels_add(data) {
    return request({
        url: `member/MemberModels/add`,
        method: 'post',
        data
    })
}


// 获取模特列表
export function MemberModels_lists(data) {
    return request({
        url: `member/MemberModels/lists?${data}`,
        method: 'get',

    })
}

// 获取模特详情
export function MemberModels_detail(data) {
    return request({
        url: `member/MemberModels/detail?${data}`,
        method: 'get',

    })
}

// 编辑模特
export function MemberModels_edit(data) {
    return request({
        url: `member/MemberModels/edit`,
        method: 'put',
        data

    })
}


// 删除模特
export function MemberModels_delete(data) {
    return request({
        url: `member/MemberModels/delete`,
        method: 'delete',
        data
    })
}


// 缴费管理


// 获取订单列表
export function order_lists(data) {
    return request({
        url: `member/order/lists?${data}`,
        method: 'get',

    })
}
// 获取订单详情
export function orderDetail(data) {
    return request({
        url: `member/order/detail?${data}`,
        method: 'get',

    })
}
// 承诺书提交
export function Members_promiseUp(data) {
    return request({
        url: `member/Members/promiseUp`,
        method: 'put',
        data

    })
}



// 发票抬头列表
export function invoiceHeaderLists(data) {
    return request({
        url: `member/InvoiceHeader/lists?${data}`,
        method: 'get',
    })
}
// 获取发票详情
export function invoiceHeaderDetail(data) {
    return request({
        url: `member/InvoiceHeader/detail?${data}`,
        method: 'get',
    })
}
//添加发票抬头
export function invoiceHeaderAdd(data) {
    return request({
        url: `member/InvoiceHeader/add`,
        method: 'post',
        data
    })
}
//修改发票抬头
export function invoiceHeaderEdit(data) {
    return request({
        url: `member/InvoiceHeader/edit`,
        method: 'put',
        data
    })
}
// 删除发票抬头
export function delInvoiceHeader(data) {
    return request({
        url: 'member/InvoiceHeader/delete',
        method: 'delete',
        data
    })
}

// 活动通知
// 活动通知列表
export function Message_lists(data) {
    return request({
        url: `member/Message/lists?${data}`,
        method: 'get',

    })
}
// 活动通知详情
export function Message_detail(data) {
    return request({
        url: `member/Message/detail?${data}`,
        method: 'get',
    })
}
// 通知列表删除
export function Message_delete(data) {
    return request({
        url: `member/Message/delete`,
        method: 'delete',
        data
    })
}
//------------------获取验证码
export function getVerify() {
    return request({
        url: 'member/Login/captcha',
        method: 'get',
    })
}
//------------------验证图形验证码
export function Login_checkCaptcha(data) {
    return request({
        url: `member/Login/checkCaptcha?${data}`,
        method: 'get',
    })
}
//------------------获取手机验证码
export function Login_sendCode(data) {
    return request({
        url: `member/Login/sendCode`,
        method: 'post',
        data
    })
}
//------------------修改密码忘记密码
export function Login_forgotPasswd(data) {
    return request({
        url: `member/login/forgotPasswd`,
        method: 'put',
        data
    })
}
//------------------申请发票
export function Order_applyInvoic(data) {
    return request({
        url: `member/Order/applyInvoic`,
        method: 'put',
        data
    })
}
// 下单
export function placeAnorder(data) {
    return request({
        url: `communal/UnifiedOrder/placeOrder`,
        method: 'post',
        data
    })
}
// 获取支付方式
export function getPaymentMethod(data) {
    return request({
        url: `communal/PayWay/getPayWay?${data}`,
        method: 'get',
        data
    })
}
// 获取订单支付状态
export function getUnifiedOrderPayStatus(data) {
    return request({
        url: `communal/UnifiedOrder/payStatus?${data}`,
        method: 'get',
        data
    })
}
// 预支付订单
export function setPrePaidOrder(data) {
    return request({
        url: `communal/UnifiedOrder/prePay`,
        method: 'post',
        data
    })
}
// 获取对公转账信息
export function getCorporateTransferInfo(data) {
    return request({
        url: `communal/PayWay/getBankInfo?${data}`,
        method: 'get',
    })
}
// 获取会员等级详情
export function getMemberLevelDetail(data) {
    return request({
        url: `member/MemberLevel/detail?${data}`,
        method: 'get',
    })
}
// 获取会员证书
export function MemberCertificate(data) {
    return request({
        url: `member/members/certificate?${data}`,
        method: 'get',
    })
}
